import rollbar from 'rollbar/dist/rollbar.umd'

const imageBucket = /\/(s3\.amazonaws\.com\/i\.machineryhost\.com|i\.machineryhost\.com\.s3\.amazonaws\.com)/i
const fileBucket = /\/(s3\.amazonaws\.com\/f\.machineryhost\.com|f\.machineryhost\.com\.s3\.amazonaws\.com)/i
const isSavedLocalHtml = window.location.protocol === 'file:'

if (!isSavedLocalHtml && ['production', 'staging'].includes(process.env.NODE_ENV)) {
  window.Rollbar = rollbar.init(_rollbarConfig) // eslint-disable-line no-undef

  if (document.body.innerHTML.match(imageBucket) || document.body.innerHTML.match(fileBucket)) {
    window.Rollbar.warning('S3 bucket URL found on the page')
  }
}
